export default {
    behavior_reportView: 'Report'
};
